import React from 'react';
import * as lodash from 'lodash';
import {Button, Checkbox, message} from 'antd';
import {WeaDialog, WeaSearchGroup, WeaFormItem, WeaInput, WeaSelect, WeaBrowser,WeaCheckbox} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EField_New from './base/EField_New'

// 我的项目，数据来源
class Content_10_DataSource extends React.Component {
    state = {
        id: this.props.tabData.id,
        title: this.props.tabData.title || '',
        projectsSource: this.props.tabData.projectsSource || this.props.tabNew.projectsSource.selected,
        projectsState: this.props.tabData.projectsState || this.props.tabNew.projectsState.selected,
        isinclude: this.props.tabData.isinclude || '0',
        eFieldNewDataSource: this.props.tabData.eFieldNewDataSource || this.props.tabNew.eFieldNewDataSource,
        eFieldNewUsedKeys: this.props.tabData.eFieldNewUsedKeys || [],
        eFieldNewVisible: false,
    };

    constructor(props) {
        super(props);
        this.getButtons = this.getButtons.bind(this);
        this.onOk = this.onOk.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    render() {
        const{ title,id,projectsSource,projectsState,isinclude, eFieldNewDataSource, eFieldNewUsedKeys, eFieldNewVisible} = this.state;
        const {tabNew} = this.props;
        let EFieldNew = <div></div>;
        if (eFieldNewVisible) {
            const eFieldNewProps = {
                eFieldNewDataSource: _.cloneDeep(eFieldNewDataSource),
                eFieldNewUsedKeys: _.cloneDeep(eFieldNewUsedKeys),
                onOk: (data) => {
                    this.setState({
                        eFieldNewDataSource: _.cloneDeep(data.eFieldNewDataSource),
                        eFieldNewUsedKeys: _.cloneDeep(data.eFieldNewUsedKeys),
                        eFieldNewVisible: false
                    });
                },
                onCancel: () => {
                    this.setState({
                        eFieldNewVisible: false
                    });
                }
            };
            EFieldNew = <EField_New {...eFieldNewProps}/>
        }
        const eFieldNewUsedNames = [];
        for (let i = 0; i < eFieldNewUsedKeys.length; i++) {
            for (let j = 0 ; j < eFieldNewDataSource.length; j++) {
                if (eFieldNewUsedKeys[i] == eFieldNewDataSource[j].key) {
                    eFieldNewUsedNames.push(eFieldNewDataSource[j].name);
                }
            }
        }
        return (
            <WeaDialog
                className="portal-esetting-dialog"
                visible={true}
                title={getLabel(19480, '内容设置')}
                icon="icon-coms-portal"
                iconBgcolor='#1a57a0'
                style={{width: 660, height: 507}}
                hasScroll={true}
                buttons={this.getButtons()}
                onCancel={this.onCancel}
            >
                <WeaSearchGroup title={getLabel(33396, '设置项')} needTigger={true} showGroup={true}>
                    <WeaFormItem label={getLabel(24986, '标题')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <WeaInput inputType="multilang" isBase64={true} value={title} viewAttr={3} onChange={value => this.setState({title: value})}/>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(28104, '项目来源')} labelCol={{span: 6}} wrapperCol={{span: 16}} >
                        <div style={{display: 'inline-block'}}>
                            <div style={{width: '100px',display: 'inline-block'}}>
                                <WeaSelect
                                   options={
                                        tabNew.projectsSource.options.map((item) => {
                                            return {key: item.key, selected: false, showname: item.value};
                                        })
                                    }
                                    value={projectsSource}
                                    onChange={value => {
                                        this.setState({
                                            projectsSource:value,
                                            isinclude:'0',      
                                        });
                                    }}
                                />
                            </div>
                            {
                                this.state.projectsSource=== '2' ?
                                    <div style={{marginLeft: 10,display: 'inline-flex'}}>
                                        <div style={{display: 'inline-flex'}}>
                                            <WeaCheckbox
                                                value={isinclude == '1'}
                                                id='test'
                                                onChange={(value) => {
                                                    this.setState({isinclude:value});
                                                }}
                                            />
                                        </div>    
                                        <span style={{ margin: '5px 5px',display: 'inline-block' }}>{getLabel(386558, '包含我负责的')}</span>
                                    </div>
                                :<div/>
                            }
                        </div>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(587, '项目状态')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        <div style={{width: '100px'}}>
                                    <WeaSelect
                                    options={
                                        tabNew.projectsState.options.map((item) => {
                                            return {key: item.key, selected: false, showname: item.value};
                                        })
                                    }
                                    value={projectsState}
                                    onChange={value => {
                                        this.setState({projectsState:value});
                                    }}
                                />
                            </div>
                    </WeaFormItem>
                    <WeaFormItem label={getLabel(19495, '显示字段')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                        {EFieldNew}
                        <div style={{height: '30px', lineHeight: '23px'}}>
                            <i className="icon-coms-Flow-setting portal-esetting-btn"
                               style={{position: "relative", zIndex: "12"}}
                               onClick={() => this.setState({eFieldNewVisible: true})}/>
                            <span className="pottal-element-showfield" style={{"margin-left":"20px"}}>{eFieldNewUsedNames.join('，')}</span>
                        </div>
                    </WeaFormItem>
                </WeaSearchGroup>
            </WeaDialog>
        );
    }

    getButtons() {
        let buttons = [];
        buttons.push(<Button type="primary" onClick={this.onOk}>{getLabel(826, '确定')}</Button>);
        buttons.push(<Button type="ghost" onClick={this.onCancel}>{getLabel(31129, '取消')}</Button>);
        return buttons;
    }

    onOk() {
        if (!this.state.title) {
            message.warning(getLabel(15859, '必要信息不完整！'));
        } else {
            this.props.onOk(this.state);
        }
    }
    onCancel() {
        this.props.onCancel();
    }
}

export default Content_10_DataSource;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_10_DataSource.js